module.exports = function(service) {
	'use strict'
	service.factory('keyPressSlugify', keyPressSlugify);
	keyPressSlugify.$inject = [];
	function keyPressSlugify() {
	   return function(evt) {
			evt = (evt) ? evt : event;
		    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
		    ((evt.which) ? evt.which : 0));
		    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode!=45 && charCode!=95 && (charCode<97 || charCode>122)) {
		        evt.preventDefault();
		    }
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/keyPressSlugifyService.js
// module id = 616
// module chunks = 0